import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=603d1724&"
import script from "./Turntable.vue?vue&type=script&lang=js&"
export * from "./Turntable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports